__turbopack_context__.v({
  "avatarImage": "avatar-module__9eilXq__avatarImage",
  "avatarMenuTrigger": "avatar-module__9eilXq__avatarMenuTrigger",
  "avatarText": "avatar-module__9eilXq__avatarText",
});
